<template>
  <div class="col-sm-12">
    <div class="card form-card p-4">
      
      <!-- Loading Indicator -->
      <div v-if="loading" class="loading-spinner mt-3">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <!-- Main Form Content -->
      <div v-else>
      <!-- First Row -->
      <div class="form-row">
        <div class="col-md-4 form-group">
          <label for="orderDateTimePicker">Loading Date and Time</label>
          <input type="datetime-local" v-model="orderDateTime" class="form-control custom-input" />
        </div>

        <div class="col-md-4 form-group">
          <label for="unloadingDateTimePicker">Unloading Date and Time</label>
          <input type="datetime-local" v-model="unloadingDateTime" class="form-control custom-input" />
        </div>

        <div class="col-md-4 form-group">
          <label for="distributor">Distributor</label>
          <select v-model="distributor" id="distributor" class="form-control custom-input" disabled>
            <option v-for="d in distributors" :key="d.id" :value="d.id">
              {{ d.distributor_name }}
            </option>
          </select>
        </div>
      </div>

      <!-- Second Row (dynamic widths + Vehicle only when bridging === 2) -->
      <div class="form-row mt-3">
        <div :class="['form-group', Number(bridging) === 2 ? 'col-md-3' : 'col-md-4']">
          <label>Bridging</label>
          <select v-model="bridging" class="form-control custom-input">
            <option v-for="b in bridgings" :key="b.id" :value="b.id">{{ b.name }}</option>
          </select>
        </div>

        <div :class="['form-group', Number(bridging) === 2 ? 'col-md-3' : 'col-md-4']">
          <label>Bridging Type</label>
          <select v-model="britype" class="form-control custom-input">
            <option disabled value="">Select Bridging Type</option>
            <option v-for="bt in britypes" :key="bt.id" :value="bt.id">{{ bt.vehicle_type }}</option>
          </select>
        </div>

        <!-- VEHICLE: show only when bridging === 2 -->
        <div v-if="Number(bridging) === 2" class="form-group col-md-3">
          <label>Vehicle</label>
          <select v-model="vehicle" class="form-control custom-input">
            <option v-for="veh in vehicles" :key="veh.id" :value="veh.id">{{ veh.vehicle_no }}</option>
          </select>
        </div>

        <div :class="['form-group', Number(bridging) === 2 ? 'col-md-3' : 'col-md-4']">
          <label>Plant</label>
          <select v-model="plant" class="form-control custom-input">
            <option v-for="p in plants" :key="p.id" :value="p.id">{{ p.name }}</option>
          </select>
        </div>
      </div>

      <!-- Third Row -->
      <div class="form-row mt-3" v-if="isApproved && plant_id !== '0'">

        <div class="col-md-6 form-group">
          <label for="sapInvoiceNo">SAP Invoice No <span class="text-danger">*</span></label>
          <input type="text" v-model="sapInvoiceNo" id="sapInvoiceNo" class="form-control custom-input" placeholder="Enter SAP Invoice No"/>
        </div>

        <div class="col-md-6 form-group">
          <label for="outDateTime">Out Date and Time</label>
          <input type="datetime-local" v-model="outDateTime" id="outDateTime" class="form-control custom-input"/>
        </div>
      </div>

      <!-- Items Table -->
      <div class="mt-4 table-container">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr class="table-header">
              <th>Item</th>
              <th>Request Quantity</th>
              <th>Quantity</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in bootstraplist" :key="item.variant_id ?? index">
              <td>{{ item.variant_name }}</td>
              <td>{{ item.request_qty }}</td>
              <td>
                <input type="number" class="form-control quantity-input" v-model.number="item.qty" min="0" placeholder="0" />
              </td>
              <td>
                <i @click="deleteItem(index)" class="fa fa-trash action-icon text-danger"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Remark and Buttons -->
      <div class="remark-section mt-4">
        <label for="remark">Remark:</label>
        <textarea
            v-model="remark"
            id="remark"
            class="form-control custom-input"
            :class="{ 'disabled-input': isApproved }"
            :disabled="isApproved"
            rows="3"
            placeholder="Add your comment here..."
        ></textarea>
      </div>

      <!-- Form Action Button -->
      <div class="d-flex justify-content-end mt-4 gap-2">
        <button type="submit" class="btn btn-success" @click="Approve" :disabled="isApproving || isRejecting">
          <span v-if="isApproving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          {{ isApproving ? 'Scheduling...' : 'Schedule' }}
        </button>
        <button v-if="!isApproved" type="submit" class="btn btn-danger" @click="Reject" :disabled="isApproving || isRejecting">
          <span v-if="isRejecting" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          {{ isRejecting ? 'Rejecting...' : 'Reject' }}
        </button>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import {
  fetchPurchaseOrderDetails,
  updatePurchaseOrder,
  fetchVehicleListOrderRequest,
  fetchPlantOrderRequest,
  fetchBridgingList,
  fetchItemNameListOrder,
  fetchVehicleType,
  poshappvoal,
  poshreject,
} from '@/services/dataService';
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      profile_id: localStorage.getItem('profile_id') || null,
      token: localStorage.getItem('token_set') || '',
      plant_id: localStorage.getItem('plant_id') || null,
      orderDateTime: '',
      unloadingDateTime: '',
      outDateTime: '',
      sapInvoiceNo: '',
      loading: false,
      bootstraplist: [],
      distributor: '',
      vehicle: '',
      plant: '',
      bridging: '',
      britype: '',
      remark: '',
      distributors: [],
      vehicles: [],
      plants: [],
      bridgings: [],
      britypes:[],
      errors: {},
      isApproved: false,
      isApproving: false,
      isRejecting: false,
    };
  },

  setup() {
    const router = useRouter();
    const navigateToNewDispatch = () => {
      router.push('/new-dispatch');
    };
    return { navigateToNewDispatch };
  },

  computed: {
    formattedBootstrapList() {
      return this.bootstraplist.map(item => ({
        ...item,
        item_id: item.item_id || item.id || '',
        variant_id: item.variant_id || '',
        qty: parseInt(item.qty) || 0,
        request_qty: parseInt(item.request_qty) || 0,
        cost: item.cost || 0,
        current_stock: item.current_stock || 0
      }));
    }
  },

  methods: {
    async loadPurchaseOrderDetails(id) {
      try {
        const response = await fetchPurchaseOrderDetails(id, this.token);
        const data = response.data.data.purchase_order;
        const details = response.data.data.purchase_order_details;

        this.orderDateTime = data.loading_date_time;
        this.unloadingDateTime = data.unload_date_time;
        this.distributor = data.distributor_id;
        this.vehicle = data.vehicle_no; // Set vehicle to vehicle_no
        this.plant = data.gas_plant_id;
        this.bridging = data.bridging_id;
        this.britype = data.vehicle_type;
        this.remark = data.remarks;
        this.isApproved = data.is_approved === '1';
        this.sapInvoiceNo = data.sap_po_no || '';
        this.outDateTime = data.plant_out_date_time
        this.distributors = [{ id: data.distributor_id, distributor_name: data.distributor_name }];
        this.vehicles = [{ id: data.vehicle_no, vehicle_no: data.vehicle_no }];
        this.plants = [{ id: data.gas_plant_id, name: data.gas_plant_name }];
        this.bridgings = [{ id: data.bridging_id, name: data.bridging_name }];
        this.britypes = [{id: data.vehicle_type, vehicle_type: data.vehicle_type_name }];

      //  const itemsResponse = await fetchItemNameListOrderEditAllItem(localStorage.getItem('company_id'), this.token);
      const isparent  =0;
      const itemsResponse = await fetchItemNameListOrder(localStorage.getItem('company_id'),undefined,this.token); 
      const items = itemsResponse.data.data;

        this.bootstraplist = items.map(item => {
          const detail = details.find(d => Number(d.variant_id) === Number(item.variant_id));
          const qty = detail ? Number(detail.qty) : 0;
          return {
            ...item,
            qty: qty > 0 ? qty : null,
            request_qty: detail ? Number(detail.request_qty) || 0 : 0,
          };
        });
      } catch (error) {
        console.error("Failed to load purchase order details:", error);
      }
    },
    async fetchVehicle() {
      try {
        const response = await fetchVehicleListOrderRequest(this.distributor, this.token);
        if (response.data.status === "success") {
          this.vehicles = response.data.data;

          const vehicleFromOrder = this.vehicles.find(vehicle => vehicle.vehicle_no === this.vehicle);
          if (!vehicleFromOrder) {
            this.vehicles.push({ id: this.vehicle, vehicle_no: this.vehicle });
          }
        } else {
          this.errors.vehicles = response.data.message;
        }
      } catch (error) {
        this.errors.vehicles = "Failed to fetch vehicles.";
      }
    },
    async fetchPlant() {
      try {
        const response = await fetchPlantOrderRequest(this.token);
        if (response.data.status === "success") {
          this.plants = response.data.data;
        } else {
          this.errors.plants = response.data.message;
        }
      } catch (error) {
        this.errors.plants = "Failed to fetch plants.";
      }
    },
    async fetchVehicleTypes() {
      try {
        const response = await fetchVehicleType(this.token);
        if (response.data.status === "success") {
          this.britypes = response.data.data;
        } else {
          this.errors.britypes = response.data.message;
        }
      } catch (error) {
        this.errors.britypes = "Failed to fetch vehicle types.";
      }
    },
    async fetchBridgings() {
      try {
        const response = await fetchBridgingList(this.token);
        if (response.data.status === "success") {
          this.bridgings = response.data.data;
        } else {
          this.errors.bridgings = response.data.message;
        }
      } catch (error) {
        this.errors.bridgings = "Failed to fetch bridgings.";
      }
    },
    deleteItem(index) {
      this.bootstraplist[index].qty = 0;
    },
    async Approve() {
      const toast = useToast();

      if (this.isApproved && this.plant_id !== '0' && !this.sapInvoiceNo?.trim()) {
        toast.error("SAP Invoice No is required.");
        return;
      }

      const payload = {
        distributor_id: this.distributor,
        purchase_orders_id: this.$route.params.id, // Replace with dynamic value as needed
        confirmed_by: parseInt(this.profile_id),
        loading_date_time: this.orderDateTime,
        unload_date_time: this.unloadingDateTime,
        bridging_id: parseInt(this.bridging),
        vehicle_type: this.britype,
        vehicle_no: this.vehicle,
        gas_plant_id: parseInt(this.plant),
        remarks: this.remark,
        plant_out_date_time: this.orderDateTime,
        sap_po_no: this.sapInvoiceNo,
        details: this.formattedBootstrapList.map(item => ({
          variant_id: item.variant_id,
          item_id: item.item_id,
          qty: item.qty,
          cost: item.cost,
          current_stock: item.current_stock,
        })),
      };

      try {
        this.isApproving = true;
        const response = await poshappvoal(payload, this.token);
        this.isApproving = false;
        if (response.status === 200) {
          const successMessage = this.plant_id === '0'
            ? "Order Confirmed Successfully!"
            : "Order Scheduled Successfully!";
          toast.success(successMessage);
          this.$router.push('/order-request-schedule');
        } else {
          const errorMessage = this.plant_id === '0'
            ? "Failed to Confirm Purchase Order."
            : "Failed to Schedule Purchase Order.";
          toast.error(errorMessage);
        }
      } catch (error) {
        this.isApproving = false;
        toast.error(`Error: ${error.response?.data?.message || "Something went wrong"}`);
      }
    },
    async Reject() {
      const toast = useToast();
      const payload = {
        purchase_orders_id: this.$route.params.id, // Replace with dynamic value as needed
      };

      try {
        this.isRejecting = true;
        const response = await poshreject(payload, this.token);
        this.isRejecting = false;
        if (response.status === 200) {
          toast.success("Purchase Order Rejected Successfully!");
          this.$router.push('/order-request-schedule');
        } else {
          toast.error("Failed to Reject Purchase Order.");
        }
      } catch (error) {
        this.isRejecting = false;
        console.error("Error updating Reject:", error);
        toast.error(`Error: ${error.response?.data?.message || "Something went wrong"}`);
      }
    },
  },

  async mounted() {
    this.loading = true;
    const orderId = this.$route.params.id;
    await this.loadPurchaseOrderDetails(orderId);
    await Promise.all([
      this.fetchVehicle(),
      this.fetchVehicleTypes(),
      this.fetchPlant(),
      this.fetchBridgings()
    ]);
    this.loading = false;
  }
};
</script>

<style scoped>
/* ----- Card Container ----- */
.form-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin-bottom: 20px;
}

/* ----- Inputs, Selects, Textareas ----- */
.custom-input {
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid #ccc;
  font-size: 14px;
  width: 100%;
  transition: all 0.3s ease;
}

.custom-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 6px rgba(0, 123, 255, 0.3);
  outline: none;
}

select.custom-input {
  appearance: auto;          /* Show default arrow */
  -webkit-appearance: auto;  /* Safari/Chrome */
  -moz-appearance: auto;     /* Firefox */
  background-color: #fff;    /* Ensure arrow visible */
  padding-right: 30px;       /* Space for arrow */
  cursor: pointer;
}

select.custom-input:disabled {
  background-color: #f5f5f5; /* light gray background */
  color: #777;              /* muted text color */
  cursor: not-allowed;      /* make it obvious it's not editable */
  border: 1px solid #ddd;   /* softer border */
}

textarea.custom-input {
  resize: vertical;
}

/* ----- Labels ----- */
label {
  font-size: 13px;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}

/* ----- Form Rows ----- */
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.form-group {
  padding: 0 8px;
  margin-bottom: 12px;
}

/* ----- Table Styles ----- */
.table-container {
  width: 100%;
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
}

.table th, .table td {
  padding: 12px 10px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  font-size: 14px;
}

.table th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.table tbody tr:hover {
  background-color: #f1f9ff;
}

/* Quantity Input inside table */
.quantity-input {
  width: 100px;
  border-radius: 6px;
  padding: 6px 8px;
  border: 1px solid #ccc;
}

/* ----- Action Icons ----- */
.action-icon {
  cursor: pointer;
  transition: transform 0.2s;
  font-size: 16px;
}

.action-icon:hover {
  transform: scale(1.2);
}

/* ----- Buttons ----- */
.btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-success {
  background-color: #28a745;
  color: #fff;
  border: none;
}

.btn-success:hover {
  background-color: #218838;
}

.btn-danger {
  background-color: #dc3545;
  color: #fff;
  border: none;
}

.btn-danger:hover {
  background-color: #c82333;
}

.d-flex.gap-2 > .btn {
  margin-left: 8px;
}

/* ----- Loading Spinner ----- */
.loading-spinner {
  font-size: 16px;
  text-align: center;
  color: #007bff;
  margin-top: 16px;
}

/* ----- Remark Section ----- */
.remark-section {
  margin-top: 20px;
}

.remark-section textarea {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.remark-section textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 6px rgba(0, 123, 255, 0.3);
  outline: none;
}

/* ----- Responsive Adjustments ----- */
@media (max-width: 991px) {
  .form-row {
    flex-direction: column;
  }
  .form-group {
    padding: 0;
  }
  .quantity-input {
    width: 100%;
  }
}
</style>